module.exports = __webpack_public_path__ + "static/media/icon-footer-address.5d4f6d36.svg";